module.exports = __webpack_public_path__ + "static/media/the-mercury.a98a62df.svg";